import { replica } from '@/shared/sync/replica';
import { cleanData } from './clean-data';
import type { CollectionName } from './collection-name';
import type { RecordSchema } from './record-schema';
import { validateRecord } from './validate-record';

/** Validate, fill defaults and queue the new record; returns its id. */
export async function createRecord(
  collection: CollectionName,
  schema: RecordSchema,
  data: Readonly<Record<string, unknown>>,
): Promise<string> {
  return replica.mutate(collection, 'upsert', validateRecord(schema, cleanData(data)));
}
